<template>
	<div class="loading">
		
			<div class="img">
				<img src="http://www.welbell.com/img/N-dncsf_SoaRjKzTDCt9OA20180911164641.jpg"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<i class="el-icon-setting"></i>&nbsp; &nbsp;<span>首页></span>
					{{sel?sel:''}}
				</div>
				
				<!--内容-->
				<div class="content">
					<ul>
								<li @click="selItem(item)" 
								:class="sel===item.title?'active':''" 
								v-for="(item,index) in navlist"
								:key="index" >
								{{item.title}}
								</li>
								
						</ul>
					<router-view/>	
				</div>
				
			</div>
			
	
		
	</div>
</template>

<script>
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'newcenter',
				navlist: [
							{
								title: '资料',
								rou: '/Loading/'
							},
							{
								title: '视频',
								rou: '/Loading/Video'
							},
							{
								title: '方案',
								rou: '/Loading/Scheme'
							}
				],
				sel:'资料'
				
			}
		},
		methods:{
			selItem(item) {
				this.sel = item.title; 
				localStorage.setItem('sel',item.title);
				this.$router.push(item.rou);
			}
		},
		created(){
			let sel =localStorage.getItem("sel");
			  if(sel){
			  	this.sel=sel;
			  }
		}

	}
</script>

<style lang="less" scoped="scoped">
.loading{
	.img{
		width:100%;
		height:550px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.news{
			width: 100px;
			height: 40px;
			color: forestgreen;
			margin-left: 5px;
			margin-right: 5px;
		}
	}
		.content{
		margin-top: 50px;
	
			ul{
				li{
					display: inline-block;
					margin-right: 40px;
					width: 120px;
					height: 40px;	
					background: #eee;	
					text-align: center;
					line-height: 40px;	
				}
				.active{
					background: #00A0FF;
					color: #fff;
				}
				
			}
			
		
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ServiceCenter/Scom/Loading.vue